import {
  ORDER_LIST,
  ORDER_DETAIL,
  ORDER_RECENT,
  LOADING,
  GET_ORDER_BY_ID,
  NOT_FOUND,
} from "../action/type";

const initialState = {
  list: [{}],
  loading: false,
  not_found: false,
  new_orders: [],
  view_order: [],
  pagination: {},
};
const order = function (state = initialState, action) {
  switch (action.type) {
    case LOADING:
      return {
        ...state,
        list: action.payload,
        loading: true,
        not_found: false,
      };
    case NOT_FOUND:
      return {
        ...state,
        list: action.payload,
        loading: false,
        not_found: true,
      };
    case GET_ORDER_BY_ID:
      return {
        ...state,
        view_order: action.payload,
        loading: false,
        not_found: false,
      };
    case ORDER_LIST:
      return {
        ...state,
        new_orders: action.payload.orders,
        pagination: action.payload.pagination,
        loading: false,
        not_found: false,
      };
    case ORDER_RECENT:
      return {
        ...state,
        list: action.payload,
        loading: false,
        not_found: false,
      };
    case ORDER_DETAIL:
      return {
        ...state,
        list: action.payload,
        loading: false,
        not_found: false,
      };
    default:
      return state;
  }
};
export default order;
